import { useState, useRef, useEffect } from 'react';
import { Form, Button, Accordion, Card, Row, Col, Modal, Image, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { PDFDocument } from 'pdf-lib';
import { adminInstance } from '../services/axiosInstance';
import { processBills } from './shared/BillProcessor';
//import { compressImage } from './shared/CompressImage';
import imageCompression from 'browser-image-compression';
import LoaderOverlay from '../Components/shared/Loader';
//import { compressImage } from '../utils/fileUtils'; // Import a utility function for compression

const NewExpenseRequestPage = () => {
    const [isIntercity, setIsIntercity] = useState(false);
    const [selectedTrip, setSelectedTrip] = useState('');
  const [days, setDays] = useState([createNewDay()]);
  const [files, setFiles] = useState([]);
  const [customerNames, setcustomerNames] = useState('');
  const fileInputRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
    const [showNewCategoryModal, setShowNewCategoryModal] = useState(false);
    const [trip, setTrip] = useState([]);
    const [tripName, setTripName] = useState('');

    useEffect(() => {
        fetchOpenTrip();
    }, []);

    const fetchOpenTrip = async () => {
        try {
            debugger;
            setIsLoading(true);
            const response = await adminInstance.get(`trip/GetEmployeeOpenTrips`);
            setTrip(response?.data?.trips || []);
        } catch (error) {
            console.error('Error fetching orders:', error.message);
            debugger;
        } finally {
            console.log('Fetch process completed.');
            setIsLoading(false);
        }
    };

    const saveTrip = async () => {
        try {
            debugger;
            setIsLoading(true);
            const response = await adminInstance.put(`trip/CreateTrip/` + tripName);
            setTrip(response?.data?.trips || []);
        } catch (error) {
            console.error('Error fetching orders:', error.message);
            debugger;
        } finally {
            console.log('Fetch process completed.');
            setIsLoading(false);
        }
    };

  function createNewDay() {
    return {
      date: new Date().toISOString().split('T')[0],
      customer: '',
      dayNote: '',
      serviceNo: '',
      expenses: { travel: [], food: 0, stay: 0, other: 0, stationary: 0, courier: 0 },
      bills: []
    };
  }

  // Calculate totals and daily subtotals
  const calculateTotals = () => {
    return days.map(day => {
      const dayTotal = 
        day.expenses.travel.reduce((t, trip) => t + (trip.amount || 0), 0) +
        Number(day.expenses.food || 0) +
        Number(day.expenses.stay || 0) +
          Number(day.expenses.other || 0) +
          Number(day.expenses.stationary || 0) +
          Number(day.expenses.courier || 0);
      return { ...day, dayTotal };
    });
  };

  const daysWithTotals = calculateTotals();
  const grandTotal = daysWithTotals.reduce((sum, day) => sum + day.dayTotal, 0);

  const addNewDay = () => setDays([...days, createNewDay()]);

  const updateDay = (index, updatedDay) => {
    const newDays = [...days];
    newDays[index] = updatedDay;
    setDays(newDays);
  };

  const handleSubmit = async () => {
       debugger;
      if (!customerNames || customerNames.trim() === "") {
          alert("Customer details cannot be empty.");
          return;
      }

       if (grandTotal <= 0) {
           alert("Please add expenses before submitting.");
           return;
      }

      if (selectedTrip === "") {
          alert("Please add Trip before submitting.");
          return;
      }

      setIsLoading(true);
     let expDay = days[0];
     let travels = expDay.expenses.travel.map(item => ({
       TRV_FROM: item.from,
       TRV_TO: item.to,
       DISTANCE: item.distance,
       MODE: item.mode,
       VEHICLE: item.vehicleType,
         AMOUNT: item.amount
     }));

     // API call here from: '', to: '', distance: '', mode: 'bike', vehicleType: 'bike'
     //const pdfDoc = await createBillPDF(expDay.bills);
     var obj = {
         Request : {
           TRAVEL_DATE: expDay.date,
           SERVICE_NO: expDay.serviceNo,
           TRAVEL_TYPE: isIntercity ? "O" : "I",
           CUSTOMER: customerNames,
           FOOD: expDay.expenses.food,
           STAY: expDay.expenses.stay,
           COURIER: expDay.expenses.courier,
           STATIONARY: expDay.expenses.stationary,
           OTHER_EXPENSE: expDay.expenses.other,
           NOTES: expDay.dayNote,
           TRIP_ID: selectedTrip
         },
         Items: travels
       };
       
         var compressedFiles = await Promise.all(
           files.map(async (file) => await compressImage(file))
         );
       const formData = new FormData();
       formData.append('data', JSON.stringify(obj));
       compressedFiles.forEach(file => formData.append('files', file));
   
      try {
          await adminInstance.post(`/expenserequest/save`, formData, {
              headers: { "Content-Type": "multipart/form-data" },
          });
          setFiles([]);
          alert('Request Saved successfully');
          navigate('/MyExpenseRequest');
      } catch (err) {
          alert('Upload failed. Please try again.');
      }
      finally {
          setIsLoading(false);
        }
     };

    // image compression
    const compressImage = async (file) => {
        const options = {
            maxSizeMB: 0.3,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
        }
        try {
            const compressedFile = await imageCompression(file, options);
            console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
            console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB

            // Convert Blob to File
            const fileName = file.name;
            const fileType = file.type;
            const compressedFileAsFile = new File([compressedFile], fileName, { type: fileType });

            return compressedFileAsFile; // Return as File instead of Blob
        } catch (error) {
            console.log(error);
        }
    }

  // PDF Creation Function
    const createBillPDF = async (images) => {
      const pdfDoc = await PDFDocument.create();
      for (const img of images) {
        const page = pdfDoc.addPage([600, 800]);
        // Add image to PDF (compressed)
      }
      return await pdfDoc.save();
    };    

  // Date validation (disallow future dates)
  const validateDate = (dateString) => {
    const selectedDate = new Date(dateString);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return selectedDate <= today;
  };

  const handleDateChange = (dayIndex, newDate) => {
    if (!validateDate(newDate)) {
      alert("Future dates are not allowed");
      return;
    }
    const updatedDay = { ...days[dayIndex], date: newDate };
    updateDay(dayIndex, updatedDay);
  };

  // Remove a day with confirmation
  const removeDay = (index) => {
    if (days.length <= 1) {
      alert("At least one day is required");
      return;
    }
    if (window.confirm("Are you sure you want to remove this day?")) {
      setDays(days.filter((_, i) => i !== index));
    }
    };


    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        //const invalidFiles = selectedFiles.filter(file => file.size > maxSize);

        //if (invalidFiles.length > 0) {
        //    setError('Each file must be less than 4MB.');
        //    setFiles([]);
        //    return;
        //}

        //setError('');
        setFiles(selectedFiles);
    };
    const navigate = useNavigate();

    return (
        <div className="card aon-card">
            <LoaderOverlay loading={isLoading} message="Loading" height="500px" />
            <div className="card-header aon-card-header">
                <div className="d-flex justify-content-between align-items-center">
                    <h4>
                        New Reimbursement Request
                    </h4>
                    <Button
                        variant="primary"
                        onClick={() => navigate('/MyExpenseRequest')}
                    >
                        Back to list
                    </Button>
                </div>
            </div>
            <div className="card-body aon-card-body">
                <div className="container">
      
      {/* Summary Card */}
      <Card className="mb-4 bg-light">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <Badge bg="secondary" className="me-2">
                {days.length} {days.length > 1 ? 'Days' : 'Day'}
              </Badge>
              <strong>Total: ₹{grandTotal.toFixed(2)}</strong>
            </div>
            {/* <Button variant="outline-primary" size="sm" onClick={addNewDay}>
              + Add Day
            </Button> */}
          </div>
        </Card.Body>
                    </Card>

                    {/* Travel Grouping */}
                    <Form.Group className="mb-3">
                        <Form.Label>Trip*</Form.Label>
                        <div className="col-md-6 d-flex align-items-center">
                            <Form.Select className="me-2" /* add margin-end for spacing */
                                onChange={(e) => setSelectedTrip(e.target.value)}>
                                <option value="">Select Trip</option>
                                {trip && trip.map((trp) => (
                                    <option key={trp.Id} value={trp.Id}>
                                        {trp.TripName}
                                    </option>
                                ))}
                            </Form.Select>
                            {trip && trip.length === 0 && < Button variant="primary" style={{ whiteSpace: 'nowrap' }} onClick={() => {

                                setShowNewCategoryModal(true);
                            }
                            }>
                                Add New Trip
                            </Button>}
                        </div>
                    </Form.Group>

      {/* General Note */}
      <Form.Group className="mb-4">
        <Form.Label>Customer Details*</Form.Label>
        <Form.Control 
          as="textarea" 
          rows={2} 
          value={customerNames}
          onChange={(e) => setcustomerNames(e.target.value)}
          placeholder="Visited Customer Details ..."
        />
      </Form.Group>

      {/* Trip Type Selection */}
      <Form.Group className="mb-3">
        <Form.Label>Trip Type</Form.Label>
        <div>
          <Button variant={isIntercity ? 'outline-primary' : 'primary'} 
                  onClick={() => setIsIntercity(false)}>
            With in City /Local
          </Button>
          <Button variant={isIntercity ? 'primary' : 'outline-primary'} 
                  className="ms-2"
                  onClick={() => setIsIntercity(true)}>
            Outstation
          </Button>
        </div>
                    </Form.Group>

                   


                    {/* New Category Modal */}
                    <Modal show={showNewCategoryModal} onHide={() => setShowNewCategoryModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Add New Trip</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form.Group className="mb-3">
                                <Form.Label>Trip Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    onChange={(e) => setTripName(e.target.value)}
                                    required
                                />
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowNewCategoryModal(false)}>
                                Cancel
                            </Button>
                            <Button variant="primary" onClick={async () => {
                                await saveTrip();
                                setShowNewCategoryModal(false);
                            }}>
                                Add Trip
                            </Button>
                        </Modal.Footer>
                    </Modal>

      {/* Days Accordion */}
      <Accordion defaultActiveKey="0" alwaysOpen>
        {daysWithTotals.map((day, dayIndex) => (
          <Accordion.Item key={dayIndex} eventKey={dayIndex.toString()}>
            <Accordion.Header>
              <div className="d-flex justify-content-between w-100">
                <span>
                  Day {dayIndex + 1} - {day.date}
                  {day.customer && ` (${day.customer})`}
                </span>
                <span className="ms-2">₹{day.dayTotal.toFixed(2)}</span>
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <DayExpenseForm 
                day={day} 
                dayIndex={dayIndex}
                updateDay={updateDay}
                isIntercity={isIntercity}
                removeDay={removeDay}
                days={days}
                handleFileChange={handleFileChange}
              />
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>

      {/* Action Buttons */}
      <div className="d-flex justify-content-between mt-4">
        {false && <Button variant="outline-secondary">Save Draft</Button>}
        <Button variant="primary" onClick={handleSubmit}>
          Submit Request (₹{grandTotal.toFixed(2)})
        </Button>
      </div>
                    </div>
                </div>
            </div>
  );
}

// Day Expense Sub-Component
function DayExpenseForm({ day, dayIndex, updateDay, isIntercity, days, removeDay, handleFileChange }) {
  const [showTravelModal, setShowTravelModal] = useState(false);
  const [newTravel, setNewTravel] = useState({
    from: '', to: '', distance: '', mode: 'bike', vehicleType: 'bike', amount: 0
  });

  const handleDayChange = (field, value) => {
    const updatedDay = { ...day, [field]: value };
    updateDay(dayIndex, updatedDay);  
  };

  const handleBillUpload = async (e) => {
    debugger;
    const files = Array.from(e.target.files);
    
    try {
      // Process bills (compress + convert to PDF)
      const pdfBlob = await processBills(files);
      
      // Create a file object from the blob
      const pdfFile = new File([pdfBlob], 'bills.pdf', {
        type: 'application/pdf',
        lastModified: Date.now()
      });

    //   const downloadUrl = URL.createObjectURL(pdfBlob);
    // const a = document.createElement('a');
    // a.href = downloadUrl;
    // a.download = 'expense-report.pdf';
    // document.body.appendChild(a);
    // a.click();
    // document.body.removeChild(a);

      // Update state with the PDF file
      const updatedDay = { ...day };
      updatedDay.bills = [pdfFile]; // Replace with single PDF
      updateDay(dayIndex, updatedDay);

    } catch (error) {
      console.error('Error processing bills:', error);
      alert('Failed to process bills. Please try again.');
    }
    };


  const handleExpenseChange = (type, value) => {
    const updatedDay = { ...day };
    updatedDay.expenses[type] = value;
    updateDay(dayIndex, updatedDay);
  };

  const addTravelExpense = () => {
    debugger;
    const amount = parseFloat(newTravel.amount);
    const updatedDay = { ...day };
    updatedDay.expenses.travel.push({ ...newTravel, amount });
    updateDay(dayIndex, updatedDay);
    setNewTravel({ from: '', to: '', distance: '', mode: '', vehicleType: '', amount: 0 });
    //setNewTravel({ from: '', to: '', distance: '', mode: 'bike', vehicleType: 'bike', amount: 0 });
    setShowTravelModal(false);
  };

  // Remove a trip with confirmation
  const removeTrip = (tripIndex) => {
    if (window.confirm("Are you sure you want to remove this trip?")) {
      const updatedDay = { ...day };
      updatedDay.expenses.travel = updatedDay.expenses.travel.filter((_, i) => i !== tripIndex);
      updateDay(dayIndex, updatedDay);
    }
  };

  return (
    <>
      {/* Date and Customer Row - Now with Remove button */}
      <Row className="mb-3">
        <Col md={4}>
          <Form.Group>
            <Form.Label>Date</Form.Label>
            <Form.Control 
              type="date" 
              value={day.date}
              onChange={(e) => handleDayChange('date', e.target.value)}
              max={new Date().toISOString().split('T')[0]}
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Service Number</Form.Label>
            <Form.Control
              type="text"
              min="0"
              value={day.serviceNo || ''}
              onChange={(e) => handleDayChange('serviceNo', e.target.value)}
              placeholder="Service Number"
            />
          </Form.Group>
        </Col>
        {/* <Col md={6}>
          <Form.Group>
            <Form.Label>Customer Visited</Form.Label>
            <Form.Select
              value={day.customer}
              onChange={(e) => handleDayChange('customer', e.target.value)}
            >
              <option value="">Select Customer</option>
              <option value="Customer A">Customer A</option>
              <option value="Customer B">Customer B</option>
              <option value="Customer C">Customer C</option>
            </Form.Select>
          </Form.Group>
        </Col> */}
        {/* <Col md={2} className="d-flex align-items-end">
          <Button 
            variant="outline-danger" 
            size="sm" 
            onClick={() => removeDay(dayIndex)}
            disabled={days.length <= 1}
          >
            Remove Day
          </Button>
        </Col> */}
      </Row>

      {/* Day Note */}
      <Form.Group className="mb-3">
        <Form.Label>Notes</Form.Label>
        <Form.Control
          as="textarea"
          rows={2}
          value={day.dayNote}
          onChange={(e) => handleDayChange('dayNote', e.target.value)}
          placeholder="Notes about this day's expenses..."
        />
      </Form.Group>

      {/* Travel Expense Card */}
      <Card className="mb-3">
        <Card.Body>
          <Card.Title>Travel Expenses</Card.Title>
          {day.expenses.travel.length === 0 ? (
            <div className="text-muted">No travels added yet</div>
          ) : (
            day.expenses.travel.map((trip, i) => (
              <div key={i} className="mb-2 d-flex justify-content-between align-items-center">
                <div className="flex-grow-1">
                  {trip.from} → {trip.to} ({trip.distance}km) - {trip.mode === 'O' ? 
                            'Own Vehicle' :
                            'Public Transport'} - {trip.vehicleType}
                </div>
                <div className="d-flex align-items-center">
                  <span className="me-2">₹{trip.amount.toFixed(2)}</span>
                  <Button 
                    variant="outline-danger" 
                    size="sm" 
                    onClick={() => removeTrip(i)}
                    title="Remove travel"
                  >
                    ×
                  </Button>
                </div>
              </div>
            ))
          )}
          <Button size="sm" onClick={() => setShowTravelModal(true)} className="mt-2">
            Add travel
          </Button>
        </Card.Body>
      </Card>

      {/* Travel Modal */}
      <Modal show={showTravelModal} onHide={() => setShowTravelModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add Travel Expense</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>From</Form.Label>
            <Form.Control 
              type="text" 
              value={newTravel.from}
              onChange={(e) => setNewTravel({...newTravel, from: e.target.value})} 
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>To</Form.Label>
            <Form.Control 
              type="text" 
              value={newTravel.to}
              onChange={(e) => setNewTravel({...newTravel, to: e.target.value})} 
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Distance (km)</Form.Label>
            <Form.Control 
              type="number" 
              min="0" 
              step="1"
              value={newTravel.distance}
              onChange={(e) => setNewTravel({...newTravel, distance: e.target.value})} 
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Mode</Form.Label>
            <Form.Select 
              value={newTravel.mode}
                          onChange={(e) => setNewTravel({ ...newTravel, mode: e.target.value, vehicleType: e.target.value === "P" ? "bus" : "bike" })}
            >
              <option >Select travel mode</option>
              <option value="P">Public Transport</option>
              <option value="O">Own Vehicle</option>
            </Form.Select>
          </Form.Group>
          {newTravel.mode === 'P' && (
            <Form.Group className="mb-3">
              <Form.Label>Vehicle Type</Form.Label>
              <Form.Select 
                value={newTravel.vehicleType}
                onChange={(e) => setNewTravel({...newTravel, vehicleType: e.target.value})}                
              >
                <option value="bus">Bus</option>
                <option value="taxi">Taxi</option>
                <option value="auto">Auto</option>
                <option value="metro">Metro</option>
                <option value="train">Train</option>  
              </Form.Select>
            </Form.Group>
          )}
          {newTravel.mode === 'O' && (
            <Form.Group className="mb-3">
              <Form.Label>Vehicle Type</Form.Label>
              <Form.Select 
                value={newTravel.vehicleType}
                onChange={(e) => setNewTravel({...newTravel, vehicleType: e.target.value})}
              >
                <option value="bike">Bike</option>
                <option value="car">Car</option>
              </Form.Select>
            </Form.Group>
          )}
          <Form.Group className="mb-3">
            <Form.Label>Amount</Form.Label>
            <Form.Control 
              type="number" 
              min="0" 
              step="1"
              value={newTravel.amount}
              onChange={(e) => setNewTravel({...newTravel, amount: e.target.value})} 
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowTravelModal(false)}>
            Cancel
          </Button>
          <Button 
            variant="primary" 
            onClick={addTravelExpense}
            disabled={!newTravel.from || !newTravel.to || !newTravel.distance}
          >
            Add Expense
          </Button>
        </Modal.Footer>
          </Modal>

      {/* Other Expenses */}
      <Row>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Food (₹)</Form.Label>
            <Form.Control
              type="number"
              min="0"
              value={day.expenses.food || ''}
              onChange={(e) => handleExpenseChange('food', e.target.value)}
            />
          </Form.Group>
        </Col>
        {isIntercity && (
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Stay (₹)</Form.Label>
              <Form.Control
                type="number"
                min="0"
                value={day.expenses.stay || ''}
                onChange={(e) => handleExpenseChange('stay', e.target.value)}
              />
            </Form.Group>
          </Col>
        )}
        <Col md={isIntercity ? 4 : 4}>
          <Form.Group className="mb-3">
            <Form.Label>Other Expenses (₹)</Form.Label>
            <Form.Control
              type="number"
              min="0"
              value={day.expenses.other || ''}
              onChange={(e) => handleExpenseChange('other', e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>

          {/* Additional Other Expenses */}
          <Row>
              <Col md={4}>
                  <Form.Group className="mb-3">
                      <Form.Label>Printing & Stationery Charge (₹)</Form.Label>
                      <Form.Control
                          type="number"
                          min="0"
                          value={day.expenses.stationary || ''}
                          onChange={(e) => handleExpenseChange('stationary', e.target.value)}
                      />
                  </Form.Group>
              </Col>
              <Col md={isIntercity ? 4 : 4}>
                  <Form.Group className="mb-3">
                      <Form.Label>Courier Charges (₹)</Form.Label>
                      <Form.Control
                          type="number"
                          min="0"
                          value={day.expenses.courier || ''}
                          onChange={(e) => handleExpenseChange('courier', e.target.value)}
                      />
                  </Form.Group>
              </Col>
          </Row>

      {/* Bill Upload */}
      <Form.Group className="mb-3">
        <Form.Label>Upload Bills</Form.Label>
        <Form.Control
                  type="file"
                  multiple
                  accept="image/*"
                  //onChange={async (e) => {
                  //    const files = Array.from(e.target.files);
                  //    const compressedFiles = await Promise.all(
                  //        files.map(async (file) => {
                  //            if (file.type.startsWith('image/')) {
                  //                return await compressImage(file); // Compress images
                  //            }
                  //            return file; // Keep PDFs as is
                  //        })
                  //    );
                  //    handleDayChange('bills', [...day.bills, ...compressedFiles]);
                  //}}
                  //onChange={handleBillUpload}
                  //onChange={(e) => handleDayChange('bills', [...day.bills, ...Array.from(e.target.files)])}
                  onChange={handleFileChange}
        />
        <div className="mt-2">
          {day.bills.length === 0 ? (
            <div className="text-muted">No bills uploaded yet</div>
          ) : (
            day.bills.map((bill, i) => (
              <div key={i} className="d-inline-block me-2 mb-2 position-relative">
                <Image 
                  thumbnail 
                  src={URL.createObjectURL(bill)} 
                  className="me-2" 
                  width={100} 
                />
                <Button 
                  variant="danger" 
                  size="sm" 
                  className="position-absolute top-0 end-0 p-0 rounded-circle"
                  style={{ width: '20px', height: '20px' }}
                  onClick={() => {
                    const updatedDay = { ...day };
                    updatedDay.bills = updatedDay.bills.filter((_, idx) => idx !== i);
                    updateDay(dayIndex, updatedDay);
                  }}
                >
                  ×
                </Button>
              </div>
            ))
          )}
        </div>
      </Form.Group>
    </>
  );
}

export default NewExpenseRequestPage;